import { AlertSeverity, AlertState } from '@core/api/alerting/alerting.enums';

import { AlertSeverityStoreModelEnum, AlertStateStoreModelEnum } from './alerting.enums';

export const mapAlertSeverityApiModelEnumToStoreModelEnum = (severity: AlertSeverity): AlertSeverityStoreModelEnum => {
  return {
    [AlertSeverity.Info]: AlertSeverityStoreModelEnum.Info,
    [AlertSeverity.Warning]: AlertSeverityStoreModelEnum.Warning,
    [AlertSeverity.Critical]: AlertSeverityStoreModelEnum.Critical,
  }[severity];
};

export const mapAlertStateApiModelEnumToStoreModelEnum = (state: AlertState): AlertStateStoreModelEnum => {
  return {
    [AlertState.Monitoring]: AlertStateStoreModelEnum.Monitoring,
    [AlertState.Firing]: AlertStateStoreModelEnum.Firing,
    [AlertState.Resolved]: AlertStateStoreModelEnum.Resolved,
    [AlertState.Dismissed]: AlertStateStoreModelEnum.Dismissed,
    [AlertState.NeverFired]: AlertStateStoreModelEnum.NeverFired,
  }[state];
};

export const mapAlertStateStoreModelEnumToApiModelEnum = (state: AlertStateStoreModelEnum): AlertState => {
  return {
    [AlertStateStoreModelEnum.Monitoring]: AlertState.Monitoring,
    [AlertStateStoreModelEnum.Firing]: AlertState.Firing,
    [AlertStateStoreModelEnum.Resolved]: AlertState.Resolved,
    [AlertStateStoreModelEnum.Dismissed]: AlertState.Dismissed,
    [AlertStateStoreModelEnum.NeverFired]: AlertState.NeverFired,
  }[state];
};
